import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { SWRConfig } from 'swr';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import { Cart } from './pages/CartCheckout';
import Checkout from './pages/Checkout';
import { About, Contact } from './pages/AboutContact';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminOrders from './pages/admin/AdminOrders';
import AdminSettings from './pages/admin/AdminSettings';
import AdminProducts from './pages/admin/AdminProducts';
import AdminReviews from './pages/admin/AdminReviews';
import Reviews from './pages/Reviews';
import Account from './pages/Account';
import { Toaster } from './components/ui/toaster';

const StoreLayout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  if (isAdmin) return children;
  return (
    <>
      <Header/>
      <CartDrawer/>
      {children}
      <Footer/>
    </>
  );
};

function App() {
  const publicUrl = process.env.PUBLIC_URL || '';
  const basename = (publicUrl === '.' || publicUrl === './' || publicUrl === '/') ? '' : publicUrl;

  return (
    <div className="App">
      <SWRConfig value={{
        revalidateOnFocus: false,
        revalidateIfStale: false,
        dedupingInterval: 60000 // 1 minute cache
      }}>
        <BrowserRouter basename={basename}>
          <ScrollToTop />
          <CartProvider>
            <StoreLayout>
              <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/shop" element={<Shop/>}/>
                <Route path="/product/:id" element={<ProductDetail/>}/>
                <Route path="/cart" element={<Cart/>}/>
                <Route path="/checkout" element={<Checkout/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/reviews" element={<Reviews/>}/>
                <Route path="/account" element={<Account/>}/>
                <Route path="/admin/login" element={<AdminLogin/>}/>
                <Route path="/admin" element={<AdminLayout/>}>
                  <Route index element={<AdminOrders/>}/>
                  <Route path="orders" element={<AdminOrders/>}/>
                  <Route path="products" element={<AdminProducts/>}/>
                  <Route path="reviews" element={<AdminReviews/>}/>
                  <Route path="settings" element={<AdminSettings/>}/>
                </Route>
              </Routes>
            </StoreLayout>
            <Toaster/>
          </CartProvider>
        </BrowserRouter>
      </SWRConfig>
    </div>
  );
}

export default App;
